import { useState } from "react";
import { Switch } from "@headlessui/react";
import { useTranslation } from "react-i18next";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Checkbox({ checked, onChange }) {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(checked);

  return (
    <Switch
      checked={enabled}
      onChange={() => {
        setEnabled(!enabled);
        onChange();
      }}
      className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-hidden focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
    >
      <span className="sr-only">{t("Use setting")}</span>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute h-full w-full rounded-md bg-white"
      />
      <span
        aria-hidden="true"
        className={classNames(
          enabled ? "bg-blue-600" : "bg-gray-200",
          "pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
        )}
      />
      <span
        aria-hidden="true"
        className={classNames(
          enabled ? "translate-x-5" : "translate-x-0",
          "pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow-sm ring-0 transition-transform duration-200 ease-in-out"
        )}
      />
    </Switch>
  );
}
